"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var userConfigurationDictionaryEntry_1 = require("owa-service/lib/factory/userConfigurationDictionaryEntry");
var userConfigurationDictionaryObject_1 = require("owa-service/lib/factory/userConfigurationDictionaryObject");
var updateUserConfiguration_1 = require("owa-session-store/lib/services/updateUserConfiguration");
function updateFavoritesUserOptionService(newFavoritesNodesRaw) {
    return updateUserConfiguration_1.default('OWA.UserOptions', [
        userConfigurationDictionaryEntry_1.default({
            DictionaryKey: userConfigurationDictionaryObject_1.default({
                Type: 'String',
                Value: ['FavoriteNodes'],
            }),
            DictionaryValue: userConfigurationDictionaryObject_1.default({
                Type: 'StringArray',
                Value: newFavoritesNodesRaw,
            }),
        }),
    ]).then(function (response) {
        var responseItem = response.Body.ResponseMessages.Items[0];
        if (responseItem.ResponseClass == 'Success') {
            return Promise.resolve();
        }
        else {
            return Promise.reject('updateUserConfiguration failed: ' + responseItem.ResponseClass);
        }
    });
}
exports.default = updateFavoritesUserOptionService;
//# sourceMappingURL=updateFavoritesUserOptionService.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/data/owa-mail-favorites-store/lib/services/updateFavoritesUserOptionService.js
// module id = 3331
// module chunks = 14 68